import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Wrapper')(
  css({
    my: 'l',
  }),
);

themeStyles.addBaseStyles('Input')(
  css({
    width: '100%',
  }),
);

themeStyles.addBaseStyles('AdditionalKmLink')(({ disabled }) =>
  css({
    display: 'inline-flex',
    gap: 'xs',
    color: disabled ? 'disabled' : undefined,
    '&:hover, &:focus': {
      borderBottomColor: disabled ? 'disabled' : undefined,
    },
  }),
);

themeStyles.addBaseStyles('AdditionalKmIcon')(
  css({
    display: 'inline-block',
    height: '16px',
    width: '16px',
  }),
);

themeStyles.addBaseStyles('WrapperAdditionalKms')(
  css({
    mt: 'm',
    textAlign: 'end',
  }),
);

themeStyles.addBaseStyles('WrapperInputAdditionalKms')(
  css({
    mt: 'l',
  }),
);

export default themeStyles;
